export const EVENT_TYPES = {
  manifestation: { label: "Manifestation", color: "#2563EB", text: "text-blue-400", bg: "bg-blue-600", border: "border-blue-500" },
  blocage_routier: { label: "Blocage routier", color: "#DC2626", text: "text-red-400", bg: "bg-red-600", border: "border-red-500" },
  perturbation_transport: { label: "Perturbation transport", color: "#EA580C", text: "text-orange-400", bg: "bg-orange-600", border: "border-orange-500" },
};

export const STATUS_LABELS = {
  prevu: "Prévu",
  en_cours: "En cours",
  termine: "Terminé",
  en_attente: "En attente",
};

export const MOD_REASON_LABELS = {
  meme_ip: "Même IP",
  doublon: "Doublon",
  points_proches: "Points trop proches",
  rafale: "Rafale d'une même IP",
};

export const RELIABILITY = {
  confirme: { label: "Confirmé", desc: "Média, collectif ou appel officiel", color: "#2563EB", glyph: "✓", badge: "bg-blue-950/80 text-blue-300 border-blue-500/50" },
  annonce: { label: "Annonce", desc: "Sans source solide", color: "#EA580C", glyph: "?", badge: "bg-orange-950/80 text-orange-300 border-orange-500/50" },
  reseaux_sociaux: { label: "Réseaux sociaux", desc: "Non vérifié", color: "#8B7FA8", glyph: "💬", badge: "bg-purple-950/70 text-purple-300 border-purple-400/40" },
};

export function normRel(r) {
  return r === "non_confirme" ? "annonce" : (r || "annonce");
}

export function haversine(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function gmapsUrl(lat, lng) {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
}
export function wazeUrl(lat, lng) {
  return `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
}
export function gmapsViewUrl(lat, lng) {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}

export function formatTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
